import supabase from '../supabase/supabase';

const db = () => supabase.schema('accounting');

const check = ({ data, error }) => {
  if (error) throw error;
  return data;
};

export const billService = {
  async getBills(organizationId) {
    if (!organizationId) return [];

    const bills = check(
      await db()
        .from('bills')
        .select('*')
        .eq('organization_id', organizationId)
        .order('created_at', { ascending: false })
    );

    return bills || [];
  },

  async getVendors(organizationId) {
    if (!organizationId) return [];

    return check(
      await db()
        .from('vendors')
        .select('id, vendor_name, company_name, currency, is_active')
        .eq('organization_id', organizationId)
        .order('vendor_name')
    ) || [];
  },

  async getBillById(organizationId, billId) {
    const bill = check(
      await db()
        .from('bills')
        .select('*')
        .eq('organization_id', organizationId)
        .eq('id', billId)
        .single()
    );

    const items = check(
      await db()
        .from('bill_items')
        .select('*')
        .eq('organization_id', organizationId)
        .eq('bill_id', billId)
        .order('sort_order')
    );

    return { ...bill, items: items || [] };
  },

  async saveBill(organizationId, bill, items, billId = null) {
    if (!organizationId) {
      throw new Error('Select a business before saving a bill.');
    }

    const taxRoundingMethod =
      bill.tax_rounding_method || 'per_line';

    if (!['per_line', 'invoice'].includes(taxRoundingMethod)) {
      throw new Error('Invalid tax rounding method.');
    }

    return check(
      await db().rpc('save_bill', {
        p_organization_id: organizationId,
        p_vendor_id: bill.vendor_id,
        p_bill_number: bill.bill_number.trim(),
        p_bill_date: bill.bill_date,
        p_due_date: bill.due_date,
        p_currency: bill.currency,
        p_notes: bill.notes || '',
        p_items: items.map(item => ({
          description: item.description.trim(),
          quantity: Number(item.quantity),
          unit_price: Number(item.unit_price),
          tax_rate: Number(item.tax_rate)
        })),
        p_bill_id: billId,
        p_tax_rounding_method: taxRoundingMethod
      })
    );
  },

  async finalizeBill(organizationId, billId) {
    return check(
      await db().rpc('finalize_bill', {
        p_organization_id: organizationId,
        p_bill_id: billId
      })
    );
  },

  
  async getBillPayments(organizationId, billId) {
    if (!organizationId || !billId) return [];

    return check(
      await db()
        .from('bill_payments')
        .select('*')
        .eq('organization_id', organizationId)
        .eq('bill_id', billId)
        .order('payment_date', { ascending: false })
        .order('created_at', { ascending: false })
    ) || [];
  },

  async recordBillPayment(organizationId, billId, payment) {
    return check(
      await db().rpc('record_bill_payment', {
        p_organization_id: organizationId,
        p_bill_id: billId,
        p_amount: Number(payment.amount),
        p_payment_date: payment.payment_date,
        p_payment_method: payment.payment_method,
        p_reference_number: payment.reference_number || '',
        p_notes: payment.notes || ''
      })
    );
  },
  
  async getAllBillPayments(organizationId) {
    if (!organizationId) return [];

    return check(
      await db()
        .from('bill_payments')
        .select(`
          id,
          organization_id,
          bill_id,
          amount,
          payment_date,
          payment_method,
          reference_number,
          notes,
          created_by,
          created_at
        `)
        .eq('organization_id', organizationId)
        .order('payment_date', { ascending: false })
        .order('created_at', { ascending: false })
    ) || [];
  }



};